var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g3, _g4, _path16, _g5, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g28, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _g29, _g30, _g31, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _g32, _path118, _path119, _path120, _path121, _path122, _g33, _path123, _path124, _path125, _path126, _g34, _path127, _path128, _path129, _g35, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 334,
    viewBox: "0 0 390 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.741 109.968V111.733C362.741 112.773 361.616 113.424 360.714 112.905L352.374 108.1C351.955 107.859 351.697 107.412 351.697 106.929V105.164C351.697 104.123 352.822 103.473 353.724 103.992L362.064 108.796C362.483 109.039 362.741 109.485 362.741 109.968Z",
    fill: "#1CE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M389.151 133.865L389.152 135.634C389.152 136.673 388.029 137.324 387.127 136.807L352.379 116.888C351.959 116.647 351.699 116.2 351.699 115.715V113.946C351.699 112.907 352.822 112.256 353.723 112.773L388.471 132.693C388.892 132.934 389.151 133.381 389.151 133.865Z",
    fill: "#1CE5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.83 143.228V144.997C374.83 146.036 373.707 146.687 372.806 146.17L352.384 134.463C351.964 134.222 351.705 133.775 351.705 133.29V131.521C351.705 130.482 352.828 129.831 353.729 130.348L374.151 142.055C374.571 142.296 374.83 142.743 374.83 143.228Z",
    fill: "#1CE5FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M383.765 139.564V141.333C383.765 142.372 382.642 143.023 381.741 142.506L352.381 125.675C351.961 125.434 351.702 124.987 351.702 124.503L351.701 122.734C351.701 121.695 352.824 121.044 353.725 121.561L383.085 138.392C383.505 138.632 383.765 139.08 383.765 139.564Z",
    fill: "#1CE5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.741 150.317V152.082C362.741 153.122 361.616 153.773 360.714 153.254L352.374 148.449C351.955 148.208 351.697 147.761 351.697 147.278V145.513C351.697 144.473 352.822 143.822 353.724 144.341L362.064 149.145C362.483 149.387 362.741 149.834 362.741 150.317Z",
    fill: "#1CE5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M389.151 174.214L389.152 175.983C389.152 177.022 388.029 177.673 387.127 177.156L352.379 157.236C351.959 156.995 351.699 156.548 351.699 156.064V154.295C351.699 153.256 352.822 152.605 353.723 153.122L388.471 173.042C388.892 173.282 389.151 173.73 389.151 174.214Z",
    fill: "url(#paint0_linear_161_21105)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.83 183.577V185.346C374.83 186.385 373.707 187.036 372.806 186.519L352.384 174.812C351.964 174.571 351.705 174.124 351.705 173.639V171.87C351.705 170.831 352.828 170.18 353.729 170.697L374.151 182.404C374.571 182.645 374.83 183.092 374.83 183.577Z",
    fill: "#1CE5FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M383.765 179.913V181.682C383.765 182.721 382.642 183.372 381.741 182.855L352.381 166.024C351.961 165.783 351.702 165.336 351.702 164.852L351.701 163.083C351.701 162.044 352.824 161.393 353.725 161.91L383.085 178.741C383.505 178.981 383.765 179.428 383.765 179.913Z",
    fill: "url(#paint1_linear_161_21105)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M340.284 83.7234C344.556 86.1894 348.004 92.1624 347.99 97.0704L347.713 194.896C347.699 199.805 344.229 201.782 339.957 199.316L196.782 116.654C192.51 114.188 189.062 108.216 189.076 103.307L189.353 5.48136C189.367 0.572356 192.837 -1.40465 197.109 1.06135L340.284 83.7234Z",
    fill: "url(#paint2_linear_161_21105)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.897 8.57734C186.815 8.52934 186.733 8.48434 186.651 8.43934C186.545 8.38134 186.439 8.32734 186.334 8.27534C186.229 8.22334 186.124 8.17434 186.021 8.12734C185.917 8.08034 185.814 8.03734 185.712 7.99634C185.607 7.95434 185.503 7.91534 185.4 7.87934C185.38 7.87234 185.36 7.86634 185.34 7.86034C185.332 7.85734 185.324 7.85534 185.317 7.85234C185.241 7.82634 185.165 7.80134 185.09 7.77834C184.983 7.74534 184.876 7.71634 184.77 7.69034C184.663 7.66334 184.558 7.64034 184.453 7.62034C184.339 7.59834 184.226 7.57934 184.114 7.56434C184.037 7.55434 183.962 7.54834 183.887 7.54134C183.876 7.54034 183.864 7.53834 183.853 7.53734C183.826 7.53534 183.797 7.53034 183.77 7.52934C183.648 7.52134 183.526 7.51634 183.407 7.51734C183.271 7.51834 183.137 7.52434 183.006 7.53634C182.854 7.55034 182.706 7.57234 182.561 7.60034C182.557 7.60134 182.554 7.60234 182.55 7.60334C182.545 7.60434 182.541 7.60634 182.536 7.60734C182.359 7.64434 182.187 7.69034 182.021 7.74934C181.802 7.82634 181.594 7.92334 181.396 8.03834L176.27 11.0173C176.618 10.8153 177 10.6713 177.41 10.5863C177.415 10.5853 177.42 10.5833 177.425 10.5823C177.833 10.4993 178.269 10.4773 178.727 10.5163C178.739 10.5173 178.751 10.5193 178.763 10.5203C179.219 10.5623 179.696 10.6643 180.192 10.8323C180.199 10.8343 180.207 10.8373 180.214 10.8393C180.718 11.0113 181.239 11.2493 181.773 11.5573L324.948 94.2193L330.074 91.2403L186.897 8.57734Z",
    fill: "url(#paint3_linear_161_21105)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M337.772 104.237C337.768 104.113 337.763 103.988 337.754 103.863C337.746 103.738 337.736 103.613 337.724 103.486C337.712 103.36 337.698 103.234 337.682 103.107C337.666 102.978 337.647 102.848 337.627 102.718C337.627 102.715 337.626 102.711 337.625 102.707C337.625 102.704 337.624 102.702 337.624 102.699C337.604 102.575 337.583 102.451 337.56 102.327C337.535 102.193 337.508 102.058 337.478 101.924C337.449 101.789 337.417 101.654 337.384 101.519C337.35 101.382 337.314 101.245 337.276 101.109C337.247 101.003 337.215 100.897 337.183 100.791C337.18 100.783 337.178 100.774 337.175 100.766C337.169 100.744 337.163 100.722 337.156 100.7C337.115 100.567 337.072 100.433 337.028 100.3C336.984 100.168 336.938 100.037 336.891 99.9064C336.845 99.7804 336.798 99.6544 336.749 99.5284C336.7 99.4024 336.65 99.2774 336.598 99.1534C336.558 99.0574 336.517 98.9623 336.475 98.8663C336.472 98.8603 336.47 98.8544 336.467 98.8484C336.458 98.8264 336.449 98.8054 336.439 98.7834C336.383 98.6584 336.327 98.5333 336.268 98.4093C336.204 98.2733 336.139 98.1384 336.071 98.0034C335.994 97.8484 335.914 97.6943 335.832 97.5403C335.744 97.3753 335.65 97.2124 335.557 97.0504C335.54 97.0214 335.526 96.9934 335.509 96.9644C335.489 96.9304 335.471 96.8954 335.451 96.8624C335.269 96.5524 335.077 96.2474 334.878 95.9494C334.72 95.7124 334.557 95.4804 334.389 95.2523C334.276 95.1003 334.162 94.9493 334.045 94.8013C333.947 94.6773 333.848 94.5543 333.747 94.4333C333.649 94.3153 333.549 94.1984 333.448 94.0844C333.349 93.9714 333.249 93.8604 333.147 93.7514C333.127 93.7294 333.106 93.7093 333.086 93.6873C333.079 93.6793 333.071 93.6724 333.064 93.6644C332.987 93.5824 332.91 93.5003 332.831 93.4203C332.723 93.3113 332.615 93.2034 332.505 93.0984C332.393 92.9914 332.28 92.8853 332.165 92.7823C332.051 92.6793 331.937 92.5803 331.821 92.4823C331.763 92.4333 331.705 92.3874 331.646 92.3394C331.633 92.3284 331.62 92.3174 331.607 92.3074C331.564 92.2724 331.521 92.2364 331.477 92.2014C331.365 92.1124 331.251 92.0264 331.137 91.9424C331.025 91.8604 330.913 91.7804 330.8 91.7034C330.691 91.6284 330.582 91.5564 330.471 91.4864C330.362 91.4174 330.253 91.3504 330.143 91.2854C330.118 91.2704 330.092 91.2554 330.067 91.2404L324.941 94.2193C325.468 94.5243 325.983 94.8833 326.48 95.2863C326.493 95.2963 326.506 95.3073 326.518 95.3183C327.009 95.7193 327.484 96.1634 327.936 96.6434C327.943 96.6514 327.951 96.6584 327.958 96.6664C328.869 97.6384 329.689 98.7544 330.38 99.9444C330.396 99.9734 330.412 100.002 330.428 100.03C330.763 100.614 331.068 101.215 331.336 101.826C331.339 101.833 331.342 101.84 331.345 101.848C331.618 102.474 331.853 103.108 332.045 103.745C332.048 103.754 332.05 103.762 332.052 103.77C332.243 104.408 332.393 105.047 332.493 105.679C332.494 105.681 332.494 105.684 332.494 105.686C332.595 106.323 332.648 106.952 332.646 107.565L332.369 205.391C332.367 205.992 332.312 206.546 332.212 207.056C332.209 207.072 332.205 207.088 332.202 207.104C332.1 207.604 331.954 208.059 331.766 208.465C331.762 208.473 331.759 208.483 331.755 208.491C331.595 208.832 331.39 209.118 331.175 209.389C331.104 209.479 331.037 209.573 330.96 209.655C330.705 209.927 330.428 210.17 330.115 210.352L335.241 207.373C335.554 207.191 335.83 206.949 336.086 206.676C336.163 206.594 336.229 206.501 336.3 206.411C336.392 206.295 336.497 206.195 336.579 206.066C336.685 205.9 336.782 205.724 336.871 205.537C336.875 205.529 336.878 205.52 336.881 205.512C336.885 205.504 336.887 205.496 336.891 205.488C336.95 205.362 337.005 205.233 337.056 205.097C337.105 204.966 337.15 204.83 337.191 204.69C337.229 204.562 337.263 204.43 337.294 204.295C337.307 204.24 337.317 204.182 337.328 204.125C337.331 204.109 337.334 204.093 337.337 204.077C337.348 204.023 337.36 203.971 337.37 203.916C337.391 203.795 337.409 203.672 337.425 203.546C337.44 203.424 337.453 203.3 337.463 203.174C337.473 203.054 337.48 202.933 337.486 202.809C337.491 202.686 337.494 202.561 337.495 202.435C337.495 202.428 337.495 202.42 337.495 202.413L337.772 104.588C337.777 104.47 337.776 104.354 337.772 104.237Z",
    fill: "url(#paint4_linear_161_21105)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M324.946 94.2174C329.218 96.6834 332.666 102.655 332.652 107.564L332.375 205.39C332.361 210.299 328.891 212.276 324.619 209.81L181.444 127.148C177.172 124.682 173.724 118.71 173.738 113.801L174.015 15.9754C174.029 11.0664 177.499 9.08937 181.771 11.5554L324.946 94.2174Z",
    fill: "#1CE5FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M230.363 97.5723C229.472 97.0583 228.555 96.7463 227.602 96.6703C217.162 95.8483 218.5 114.624 208.066 111.797C207.231 111.395 191.377 103.76 185.27 109.63L315.072 184.571C314.798 184.018 309.601 173.505 300.61 168.314C300.01 167.968 299.396 167.649 298.766 167.36C298.535 167.254 298.309 167.137 298.089 167.01C293.533 164.379 291.16 157.292 288.992 150.313C286.829 143.327 284.865 136.465 281.142 134.316C280.905 134.179 280.662 134.062 280.41 133.964C272.928 131.077 270.427 147.783 260.732 142.186C259.612 141.539 258.397 140.596 257.066 139.29C245.4 127.822 239.226 102.691 230.363 97.5723Z",
    fill: "url(#paint5_linear_161_21105)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M226.164 68.0694C225.273 67.5554 224.545 67.9694 224.542 68.9934L224.506 81.6224L231.296 85.5434L231.332 72.9134C231.335 71.8894 230.612 70.6374 229.721 70.1224L226.164 68.0694Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.196 53.7384C214.305 53.2244 213.577 53.6324 213.574 54.6624L213.516 75.2774L220.306 79.1984L220.365 58.5834C220.368 57.5534 219.645 56.3064 218.754 55.7924L215.196 53.7384Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M204.215 43.3044C203.318 42.7864 202.596 43.2043 202.593 44.2283L202.523 68.9314L209.308 72.8484L209.378 48.1454C209.381 47.1214 208.664 45.8724 207.767 45.3544L204.215 43.3044Z",
    fill: "url(#paint6_linear_161_21105)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.23 33.0504C192.339 32.5364 191.611 32.9504 191.608 33.9744L191.527 62.5824L198.318 66.5034L198.399 37.8954C198.402 36.8714 197.679 35.6184 196.788 35.1044L193.23 33.0504Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259.962 104.884C259.426 104.428 258.893 103.928 258.365 103.385C258.893 103.929 259.426 104.429 259.962 104.884Z",
    fill: "#757777"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M257.31 102.229L255.49 106.456C255.836 106.849 256.189 107.233 256.551 107.603C257.612 108.697 258.69 109.667 259.772 110.51C260.724 111.252 261.678 111.896 262.624 112.443C263.493 112.944 264.356 113.363 265.204 113.7L264.432 107.674C263.842 107.433 263.244 107.141 262.642 106.793C261.752 106.279 260.852 105.643 259.959 104.884C259.423 104.428 258.89 103.929 258.362 103.385C258.002 103.014 257.649 102.626 257.31 102.229Z",
    fill: "url(#paint7_linear_161_21105)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.215 77.3584C243.966 84.9154 247.665 97.6544 255.491 106.455L257.311 102.228C252.003 96.0384 249.537 87.2944 251.783 82.0644C253.616 77.8024 258.053 77.1154 262.738 79.8214C263.873 80.4774 265.025 81.3334 266.157 82.3854C266.45 82.6594 266.739 82.9364 267.032 83.2364C273.057 89.4464 276.005 98.9944 273.609 104.554C272.01 108.275 268.432 109.274 264.434 107.673L265.206 113.699C264.357 113.362 263.495 112.944 262.626 112.442C261.68 111.895 260.725 111.251 259.774 110.509C260.732 111.256 261.69 111.904 262.643 112.453C269.289 116.29 275.581 115.314 278.182 109.267C281.577 101.373 277.396 87.8294 268.846 79.0174C268.561 78.7254 268.275 78.4474 267.99 78.1724C267.922 78.1024 267.849 78.0384 267.777 77.9704C266.1 76.3904 264.416 75.1304 262.754 74.1704C256.107 70.3364 249.816 71.3124 247.215 77.3584Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.608 99.7314C294.963 95.8944 288.672 96.8734 286.073 102.92C282.821 110.48 286.519 123.214 294.349 132.022L296.165 127.793C290.861 121.605 288.391 112.859 290.641 107.631C292.474 103.368 296.908 102.68 301.592 105.385C302.734 106.044 303.891 106.906 305.028 107.965L306.845 103.737C305.116 102.073 303.349 100.737 301.608 99.7314Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.847 103.736L305.032 107.961C305.318 108.228 305.605 108.507 305.887 108.8C311.916 115.012 314.86 124.554 312.468 130.121C312.38 130.32 312.288 130.512 312.188 130.7C312.153 130.768 312.115 130.833 312.076 130.898C310.332 133.968 306.992 134.718 303.288 133.233C302.71 133.003 302.121 132.715 301.528 132.372C301.37 132.281 301.211 132.186 301.052 132.087C300.762 131.907 300.542 131.757 300.325 131.61L300.226 131.54C299.75 131.203 299.278 130.839 298.802 130.433C298.745 130.383 298.684 130.33 298.623 130.277C298.448 130.124 298.273 129.966 298.098 129.803C298.033 129.744 297.969 129.685 297.904 129.621C297.675 129.406 297.448 129.182 297.223 128.952C296.858 128.574 296.508 128.188 296.166 127.794L294.35 132.023C294.696 132.411 295.046 132.798 295.407 133.168C295.73 133.499 296.054 133.817 296.381 134.125C296.472 134.213 296.563 134.301 296.658 134.386C296.905 134.617 297.156 134.841 297.407 135.06C297.491 135.135 297.575 135.209 297.659 135.28C298.333 135.853 299.01 136.38 299.684 136.852C299.738 136.892 299.791 136.927 299.844 136.962C300.152 137.179 300.46 137.379 300.765 137.573L300.872 137.639C301.082 137.769 301.292 137.894 301.501 138.016C302 138.304 302.496 138.565 302.99 138.8C303.363 138.977 303.714 139.126 304.064 139.267C309.715 141.508 314.774 140.093 317.035 134.828C320.43 126.934 316.249 113.39 307.702 104.581C307.417 104.289 307.132 104.008 306.847 103.736Z",
    fill: "url(#paint8_linear_161_21105)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.081 189.379L123.483 242.61C119.631 244.848 114.876 244.855 111.018 242.628L18.7713 189.369C15.1913 187.302 15.1843 182.138 18.7583 180.061L110.909 126.508C114.418 124.469 118.75 124.463 122.265 126.492L215.067 180.071C218.648 182.137 218.655 187.302 215.081 189.379Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2624 178.536L67.9524 196.731L67.9414 202.135L98.5744 184.333C99.0004 184.086 99.2624 183.63 99.2624 183.138V178.536Z",
    fill: "url(#paint9_linear_161_21105)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5156 178.536V183.193C36.5156 183.687 36.7796 184.144 37.2076 184.391L67.9416 202.136L67.9526 196.687L36.5156 178.536Z",
    fill: "url(#paint10_linear_161_21105)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7696 179.272L69.2956 196.4C68.4646 196.883 67.4396 196.884 66.6076 196.404L36.9346 179.272C36.3846 178.954 36.3836 178.161 36.9326 177.842L66.2066 160.83C67.1606 160.275 68.3386 160.274 69.2946 160.825L98.7676 177.842C99.3166 178.16 99.3176 178.953 98.7696 179.272Z",
    fill: "#F2F8FD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7767 179.451L69.1157 189.714C68.3727 190.146 67.4567 190.147 66.7127 189.717L48.9267 179.448C48.2367 179.05 48.2347 178.054 48.9247 177.653L66.6917 167.328C67.3687 166.935 68.2037 166.934 68.8817 167.325L86.7747 177.656C87.4647 178.055 87.4657 179.051 86.7767 179.451Z",
    fill: "url(#paint11_linear_161_21105)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9759 100.16L67.4689 114.402L67.4609 193.186L91.4379 179.252C91.7709 179.058 91.9759 178.702 91.9759 178.316V100.16Z",
    fill: "url(#paint12_linear_161_21105)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8613 100.16V178.359C42.8613 178.746 43.0673 179.104 43.4023 179.297L67.4593 193.186L67.4673 114.367L42.8613 100.16Z",
    fill: "url(#paint13_linear_161_21105)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.007 205.842L118.697 224.037L118.686 229.441L149.319 211.639C149.745 211.392 150.007 210.936 150.007 210.444V205.842Z",
    fill: "url(#paint14_linear_161_21105)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2598 205.842V210.499C87.2598 210.993 87.5238 211.45 87.9518 211.697L118.686 229.442L118.697 223.993L87.2598 205.842Z",
    fill: "url(#paint15_linear_161_21105)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.514 206.578L120.04 223.706C119.209 224.189 118.184 224.19 117.352 223.71L87.6788 206.578C87.1288 206.261 87.1278 205.467 87.6768 205.148L116.951 188.136C117.905 187.581 119.083 187.58 120.039 188.131L149.512 205.148C150.062 205.465 150.063 206.259 149.514 206.578Z",
    fill: "#F2F8FD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M137.521 206.757L119.86 217.02C119.117 217.452 118.201 217.453 117.457 217.023L99.671 206.754C98.981 206.356 98.979 205.36 99.668 204.959L117.435 194.634C118.112 194.241 118.947 194.24 119.625 194.631L137.518 204.962C138.208 205.36 138.21 206.356 137.521 206.757Z",
    fill: "url(#paint16_linear_161_21105)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M142.718 127.465L118.211 141.707L118.203 220.491L142.18 206.557C142.513 206.363 142.719 206.007 142.719 205.621L142.718 127.465Z",
    fill: "url(#paint17_linear_161_21105)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6055 127.465V205.664C93.6055 206.051 93.8115 206.409 94.1475 206.602L118.204 220.491L118.212 141.672L93.6055 127.465Z",
    fill: "url(#paint18_linear_161_21105)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148.186 152.012L116.876 170.207L116.865 175.611L147.498 157.809C147.924 157.562 148.186 157.106 148.186 156.614V152.012Z",
    fill: "url(#paint19_linear_161_21105)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4395 152.012V156.669C85.4395 157.163 85.7035 157.62 86.1315 157.867L116.865 175.612L116.876 170.163L85.4395 152.012Z",
    fill: "url(#paint20_linear_161_21105)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M147.692 152.748L118.218 169.876C117.387 170.359 116.362 170.36 115.529 169.88L85.8565 152.748C85.3065 152.431 85.3055 151.637 85.8545 151.318L115.128 134.306C116.082 133.751 117.26 133.75 118.216 134.302L147.689 151.319C148.24 151.636 148.241 152.429 147.692 152.748Z",
    fill: "#F2F8FD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M135.701 152.927L118.04 163.19C117.297 163.622 116.381 163.623 115.637 163.194L97.8507 152.925C97.1607 152.527 97.1587 151.531 97.8477 151.13L115.615 140.805C116.292 140.412 117.127 140.411 117.805 140.802L135.698 151.132C136.389 151.531 136.39 152.526 135.701 152.927Z",
    fill: "url(#paint21_linear_161_21105)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.898 73.6364L116.391 87.8784L116.383 166.662L140.36 152.728C140.693 152.534 140.898 152.178 140.898 151.792V73.6364Z",
    fill: "url(#paint22_linear_161_21105)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7852 73.6364V151.835C91.7852 152.222 91.9912 152.58 92.3272 152.773L116.384 166.662L116.392 87.8434L91.7852 73.6364Z",
    fill: "url(#paint23_linear_161_21105)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M197.108 178.536L165.798 196.731L165.787 202.135L196.42 184.333C196.846 184.086 197.108 183.63 197.108 183.138V178.536Z",
    fill: "url(#paint24_linear_161_21105)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M134.361 178.536V183.193C134.361 183.687 134.625 184.144 135.053 184.391L165.787 202.136L165.798 196.687L134.361 178.536Z",
    fill: "url(#paint25_linear_161_21105)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M196.615 179.272L167.141 196.4C166.31 196.883 165.285 196.884 164.453 196.404L134.78 179.272C134.23 178.954 134.229 178.161 134.778 177.842L164.052 160.83C165.006 160.275 166.184 160.274 167.139 160.825L196.613 177.842C197.163 178.16 197.164 178.953 196.615 179.272Z",
    fill: "#F2F8FD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184.623 179.451L166.962 189.714C166.219 190.146 165.302 190.147 164.559 189.717L146.773 179.448C146.083 179.05 146.081 178.054 146.77 177.653L164.537 167.328C165.214 166.935 166.049 166.934 166.727 167.325L184.62 177.656C185.31 178.055 185.312 179.051 184.623 179.451Z",
    fill: "url(#paint26_linear_161_21105)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M189.82 100.16L165.313 114.402L165.305 193.186L189.282 179.252C189.615 179.058 189.82 178.702 189.82 178.316V100.16Z",
    fill: "url(#paint27_linear_161_21105)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.707 100.16V178.359C140.707 178.746 140.913 179.104 141.249 179.297L165.306 193.186L165.314 114.367L140.707 100.16Z",
    fill: "url(#paint28_linear_161_21105)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4537 156.358C57.6697 156.483 57.8447 156.785 57.8437 157.034L57.8247 163.836C57.8237 164.084 57.6477 164.184 57.4317 164.06L48.8197 159.088C48.6027 158.963 48.4287 158.66 48.4297 158.412L48.4487 151.61C48.4497 151.361 48.6257 151.261 48.8417 151.386L57.4537 156.358Z",
    fill: "#FAFAFA"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8727 170.625C64.0887 170.75 64.2637 171.052 64.2627 171.301L64.2437 178.103C64.2427 178.351 64.0667 178.452 63.8507 178.327L55.2387 173.355C55.0227 173.23 54.8477 172.927 54.8477 172.679L54.8667 165.877C54.8677 165.628 55.0437 165.528 55.2597 165.653L63.8727 170.625Z",
    fill: "#FAFAFA"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4623 150.887C62.5603 150.944 62.6393 151.081 62.6393 151.194L62.6303 154.284C62.6303 154.397 62.5503 154.442 62.4523 154.386L58.5393 152.127C58.4413 152.07 58.3613 151.933 58.3613 151.82L58.3703 148.73C58.3703 148.617 58.4503 148.571 58.5493 148.628L62.4623 150.887Z",
    fill: "#FAFAFA"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.725 116.243C102.941 116.368 103.116 116.67 103.115 116.919L103.096 123.721C103.095 123.969 102.919 124.07 102.703 123.945L94.0912 118.973C93.8752 118.848 93.7002 118.545 93.7012 118.297L93.7202 111.495C93.7212 111.246 93.8972 111.146 94.1132 111.271L102.725 116.243Z",
    fill: "#FAFAFA"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.145 130.51C109.361 130.635 109.536 130.937 109.535 131.186L109.516 137.988C109.515 138.236 109.34 138.337 109.123 138.212L100.511 133.24C100.295 133.115 100.12 132.812 100.121 132.564L100.14 125.762C100.141 125.513 100.317 125.413 100.533 125.538L109.145 130.51Z",
    fill: "#FAFAFA"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.735 110.772C107.833 110.829 107.913 110.966 107.912 111.079L107.903 114.169C107.903 114.282 107.823 114.327 107.725 114.271L103.812 112.012C103.714 111.955 103.634 111.818 103.635 111.705L103.644 108.615C103.644 108.502 103.724 108.457 103.823 108.513L107.735 110.772Z",
    fill: "#FAFAFA"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.067 178.738C105.283 178.863 105.458 179.165 105.457 179.414L105.438 186.216C105.437 186.464 105.261 186.565 105.045 186.44L96.433 181.468C96.216 181.343 96.042 181.04 96.043 180.792L96.062 173.99C96.063 173.741 96.239 173.641 96.455 173.766L105.067 178.738Z",
    fill: "#FAFAFA"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.488 193.006C111.704 193.131 111.879 193.433 111.878 193.682L111.859 200.484C111.858 200.732 111.683 200.833 111.466 200.708L102.854 195.736C102.637 195.611 102.463 195.308 102.463 195.06L102.482 188.258C102.483 188.009 102.659 187.909 102.875 188.034L111.488 193.006Z",
    fill: "#FAFAFA"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.077 173.267C110.175 173.324 110.255 173.461 110.254 173.574L110.245 176.664C110.245 176.777 110.165 176.822 110.067 176.766L106.154 174.507C106.056 174.45 105.976 174.313 105.977 174.2L105.986 171.11C105.986 170.997 106.066 170.952 106.165 171.008L110.077 173.267Z",
    fill: "#FAFAFA"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.653 155.322C153.869 155.447 154.044 155.749 154.043 155.998L154.024 162.8C154.023 163.048 153.847 163.149 153.631 163.024L145.019 158.052C144.802 157.927 144.628 157.624 144.629 157.376L144.648 150.574C144.649 150.325 144.825 150.225 145.041 150.35L153.653 155.322Z",
    fill: "#FAFAFA"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.074 169.589C160.29 169.714 160.465 170.016 160.464 170.265L160.445 177.067C160.444 177.315 160.269 177.416 160.052 177.291L151.44 172.319C151.224 172.194 151.049 171.891 151.049 171.643L151.068 164.841C151.069 164.592 151.245 164.492 151.461 164.617L160.074 169.589Z",
    fill: "#FAFAFA"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.663 149.851C158.761 149.908 158.841 150.045 158.84 150.158L158.831 153.248C158.831 153.361 158.751 153.406 158.653 153.35L154.74 151.091C154.642 151.034 154.562 150.897 154.563 150.784L154.572 147.694C154.572 147.581 154.652 147.536 154.751 147.592L158.663 149.851Z",
    fill: "#FAFAFA"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.7357 159.774C78.5197 159.899 78.3447 160.201 78.3457 160.45L78.3647 167.252C78.3657 167.5 78.5417 167.6 78.7577 167.476L87.3697 162.504C87.5867 162.379 87.7607 162.076 87.7597 161.828L87.7407 155.026C87.7397 154.777 87.5637 154.677 87.3477 154.802L78.7357 159.774Z",
    fill: "#FAFAFA"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3158 174.042C72.0998 174.167 71.9248 174.469 71.9258 174.718L71.9448 181.52C71.9458 181.768 72.1208 181.869 72.3378 181.744L80.9498 176.772C81.1668 176.647 81.3408 176.344 81.3408 176.096L81.3218 169.294C81.3208 169.045 81.1448 168.945 80.9288 169.07L72.3158 174.042Z",
    fill: "#FAFAFA"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7258 154.303C73.6278 154.36 73.5488 154.497 73.5488 154.61L73.5578 157.7C73.5578 157.813 73.6378 157.858 73.7358 157.802L77.6488 155.543C77.7468 155.486 77.8268 155.349 77.8258 155.236L77.8168 152.146C77.8168 152.033 77.7368 151.988 77.6378 152.044L73.7258 154.303Z",
    fill: "#FAFAFA"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.193 126.357C127.977 126.482 127.802 126.784 127.803 127.033L127.822 133.835C127.823 134.083 127.999 134.183 128.215 134.059L136.827 129.087C137.044 128.962 137.218 128.659 137.218 128.411L137.199 121.609C137.198 121.36 137.022 121.26 136.806 121.385L128.193 126.357Z",
    fill: "#FAFAFA"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.773 140.624C121.557 140.749 121.382 141.051 121.383 141.3L121.402 148.102C121.403 148.35 121.578 148.45 121.795 148.326L130.407 143.354C130.624 143.229 130.798 142.926 130.798 142.678L130.779 135.876C130.778 135.627 130.603 135.527 130.386 135.652L121.773 140.624Z",
    fill: "#FAFAFA"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.183 120.886C123.085 120.943 123.006 121.08 123.006 121.193L123.015 124.283C123.015 124.396 123.095 124.441 123.193 124.385L127.106 122.126C127.204 122.069 127.284 121.932 127.284 121.819L127.275 118.729C127.275 118.616 127.195 118.57 127.096 118.627L123.183 120.886Z",
    fill: "#FAFAFA"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.677 157.358C177.461 157.483 177.286 157.785 177.287 158.034L177.306 164.836C177.307 165.084 177.483 165.184 177.699 165.06L186.311 160.088C186.528 159.963 186.702 159.661 186.702 159.412L186.683 152.61C186.682 152.361 186.506 152.261 186.29 152.386L177.677 157.358Z",
    fill: "#FAFAFA"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.257 171.625C171.041 171.75 170.866 172.052 170.867 172.301L170.886 179.103C170.887 179.351 171.062 179.452 171.279 179.327L179.891 174.355C180.107 174.23 180.282 173.927 180.282 173.679L180.263 166.877C180.262 166.628 180.086 166.528 179.87 166.653L171.257 171.625Z",
    fill: "#FAFAFA"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.667 151.887C172.569 151.944 172.489 152.081 172.49 152.194L172.499 155.284C172.499 155.397 172.579 155.442 172.677 155.386L176.59 153.127C176.688 153.07 176.768 152.933 176.767 152.82L176.758 149.73C176.758 149.617 176.678 149.571 176.579 149.628L172.667 151.887Z",
    fill: "#FAFAFA"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.111 187.089C129.895 187.214 129.72 187.516 129.721 187.765L129.74 194.567C129.741 194.815 129.917 194.916 130.133 194.791L138.745 189.819C138.962 189.694 139.136 189.391 139.135 189.143L139.116 182.341C139.115 182.092 138.939 181.992 138.723 182.117L130.111 187.089Z",
    fill: "#FAFAFA"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.691 201.356C123.475 201.481 123.3 201.783 123.301 202.032L123.32 208.834C123.321 209.082 123.496 209.183 123.713 209.058L132.325 204.086C132.542 203.961 132.716 203.658 132.716 203.41L132.697 196.608C132.696 196.359 132.52 196.259 132.304 196.384L123.691 201.356Z",
    fill: "#FAFAFA"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.101 181.618C125.003 181.675 124.923 181.812 124.924 181.925L124.933 185.015C124.933 185.128 125.013 185.173 125.111 185.117L129.024 182.858C129.122 182.801 129.202 182.664 129.201 182.551L129.192 179.461C129.192 179.348 129.112 179.302 129.013 179.359L125.101 181.618Z",
    fill: "#FAFAFA"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1555 126.06C52.1555 127.017 51.3795 127.793 50.4225 127.793C49.4655 127.793 48.6895 127.017 48.6895 126.06C48.6895 125.103 49.4655 124.327 50.4225 124.327C51.3795 124.327 52.1555 125.103 52.1555 126.06Z",
    fill: "url(#paint29_radial_161_21105)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M115.968 98.1714C115.968 99.1284 115.192 99.9044 114.235 99.9044C113.278 99.9044 112.502 99.1284 112.502 98.1714C112.502 97.2144 113.278 96.4384 114.235 96.4384C115.192 96.4384 115.968 97.2144 115.968 98.1714Z",
    fill: "url(#paint30_radial_161_21105)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0748 151.191C79.0319 151.191 79.8078 150.415 79.8078 149.458C79.8078 148.501 79.0319 147.725 78.0748 147.725C77.1177 147.725 76.3418 148.501 76.3418 149.458C76.3418 150.415 77.1177 151.191 78.0748 151.191Z",
    fill: "url(#paint31_radial_161_21105)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M108.562 147.151C110.029 147.151 111.218 145.962 111.218 144.495C111.218 143.028 110.029 141.839 108.562 141.839C107.095 141.839 105.906 143.028 105.906 144.495C105.906 145.962 107.095 147.151 108.562 147.151Z",
    fill: "url(#paint32_radial_161_21105)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M134.166 155.423C134.166 155.815 133.849 156.132 133.457 156.132C133.065 156.132 132.748 155.814 132.748 155.423C132.748 155.031 133.065 154.714 133.457 154.714C133.849 154.714 134.166 155.031 134.166 155.423Z",
    fill: "url(#paint33_radial_161_21105)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6747 228.55C66.6947 235.202 56.1637 240.627 43.1517 240.667C30.1397 240.707 19.5747 235.347 19.5547 228.694C19.5347 222.042 30.0657 216.617 43.0777 216.577C56.0887 216.537 66.6537 221.898 66.6747 228.55Z",
    fill: "url(#paint34_linear_161_21105)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7741 227.739C57.7861 231.766 51.4101 235.051 43.5321 235.075C35.6541 235.099 29.2581 231.854 29.2461 227.826C29.2341 223.799 35.6101 220.514 43.4881 220.49C51.3661 220.466 57.7621 223.711 57.7741 227.739Z",
    fill: "url(#paint35_linear_161_21105)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4184 227.495C38.4184 227.495 38.2114 229.341 38.3334 230.033C38.5194 230.503 39.0724 230.415 39.3544 230.303C39.5914 230.187 39.6284 229.78 39.6284 229.78C39.6284 229.78 39.6714 229.786 39.9304 229.944C40.1894 230.103 40.7944 229.928 41.0924 229.636C41.3904 229.344 42.8894 228.836 43.0764 227.717C42.7724 227.554 41.3654 228.068 40.7014 227.875C40.0374 227.681 39.7644 227.158 39.7644 227.158L38.4184 227.495Z",
    fill: "#642F41"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8447 209.45C40.8447 209.45 40.6117 216.332 40.3887 217.857C40.3227 219.668 39.8387 227.346 39.8387 227.346C39.8157 227.617 38.8587 228.169 38.4397 227.77C38.1187 227.288 37.3677 222.318 37.8257 220.178C38.2837 218.038 36.4827 212.614 36.8507 210.466C37.2187 208.318 40.7257 206.624 40.8447 209.45Z",
    fill: "#FF9D6F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0005 228.351C42.4415 227.981 41.9675 227.82 41.9675 227.82C41.9675 227.82 41.9745 227.851 41.9765 227.817C41.5175 227.897 41.0235 227.969 40.7025 227.875C40.0385 227.681 39.7655 227.158 39.7655 227.158L38.4195 227.495C38.4195 227.495 38.3855 227.885 38.3535 228.394C38.8105 228.764 39.6375 228.232 40.2135 228.536C40.8325 228.862 41.5595 228.721 42.0005 228.351Z",
    fill: "#FF9D6F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4392 217.417C40.5562 216.229 40.6702 213.834 40.7472 211.977L36.8082 210.866C36.7522 211.901 37.0242 213.432 37.3102 214.996C38.1722 215.414 39.5542 216.221 40.4392 217.417Z",
    fill: "#FF7C40"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1855 227.595C43.1855 227.595 43.1855 229.45 43.3665 230.129C43.5925 230.581 44.1355 230.446 44.4075 230.31C44.6335 230.174 44.5885 229.767 44.5885 229.767C44.5885 229.767 44.6785 229.767 44.9505 229.903C45.2215 230.039 45.8105 230.355 46.0815 230.039C46.3525 229.722 47.7555 228.546 47.8455 227.415C47.5285 227.279 46.1715 227.913 45.4925 227.777C44.8135 227.641 44.4975 227.144 44.4975 227.144L43.1855 227.595Z",
    fill: "#642F41"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0449 209.408C44.0449 209.408 44.4069 216.285 44.3159 217.823C44.4059 219.633 44.5869 227.324 44.5869 227.324C44.5869 227.595 43.6819 228.229 43.2299 227.867C42.8679 227.415 41.6919 222.528 41.9629 220.357C42.2339 218.186 39.9719 212.937 40.1529 210.766C40.3349 208.594 43.6829 206.603 44.0449 209.408Z",
    fill: "#FF9D6F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8275 228.138C47.2345 227.731 46.7485 227.612 46.7485 227.612C46.7485 227.612 46.7585 227.642 46.7565 227.608C46.3055 227.728 45.8205 227.842 45.4925 227.776C44.8135 227.64 44.4975 227.143 44.4975 227.143L43.1855 227.595C43.1855 227.595 43.1855 227.987 43.1975 228.496C43.6855 228.825 44.4625 228.224 45.0625 228.477C45.7075 228.749 46.4205 228.546 46.8275 228.138Z",
    fill: "#FF9D6F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7792 204.929C37.7792 204.929 35.8112 207.915 36.4902 211.444C36.8972 213.548 37.2362 214.498 37.2362 214.498C37.2362 214.498 39.8152 215.652 42.7332 215.177C44.7012 214.634 44.7692 214.159 44.7692 214.159C44.7692 214.159 44.7692 207.916 44.5652 206.626C44.3612 205.336 37.7792 204.929 37.7792 204.929Z",
    fill: "#642F41"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4233 194.987C43.3623 193.282 41.0553 192.78 41.0553 192.78C38.2243 192.201 37.3243 193.23 37.3243 193.23C37.3243 193.23 36.4023 194.315 36.4023 195.781C36.4023 196.786 37.4583 199.687 37.5303 201.988C37.5003 203.584 36.5183 206.236 36.4783 206.642C36.3993 207.434 39.0913 209.729 43.9993 208.463C44.5533 208.146 44.7913 207.75 44.7913 207.75L44.8443 201.816C44.8663 201.484 44.8893 201.139 44.9123 200.768C45.1563 196.86 44.4233 194.987 44.4233 194.987Z",
    fill: "#047CFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4609 196.39L53.5989 195.697L53.6389 194.787C53.6389 194.787 53.7969 194.609 53.9749 194.728C54.1529 194.847 54.1529 195.124 54.1529 195.124L54.3709 195.401L53.4609 196.39Z",
    fill: "#FF7C40"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3241 193.23C37.3241 193.23 35.2701 194.413 34.9551 199.826C35.2181 200.825 36.7941 201.35 38.0031 200.562C39.2121 199.774 37.9591 194.149 37.3241 193.23Z",
    fill: "#047CFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0635 194.875C55.0635 194.875 55.5125 195.518 55.5915 195.952C55.6705 196.387 55.0775 197.256 54.7615 197.493C54.4455 197.73 53.6945 197.809 53.6945 197.809C53.6945 197.809 49.8605 200.378 49.2285 200.418C48.5965 200.457 47.6875 200.102 47.7665 199.074C47.7665 199.074 52.4695 196.979 53.1025 196.623C53.7345 196.267 54.2095 194.963 54.4465 194.686C54.4465 194.686 54.9305 194.042 55.0195 193.968C55.1085 193.894 55.6135 193.731 55.6135 193.731C55.6135 193.731 55.9995 193.597 56.0445 193.612C56.0885 193.627 56.1335 193.879 55.9105 194.042C55.6875 194.205 55.2875 194.339 55.2875 194.339L55.0635 194.875Z",
    fill: "#FF9D6F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8446 190.712C38.8446 190.712 39.0886 192.137 38.8446 192.789C38.8036 193.115 40.2286 194.214 41.4916 193.929C42.2246 193.766 42.1836 193.4 42.1836 193.4C42.1836 193.4 41.5726 192.382 41.6546 191.405C41.7356 190.427 39.6996 190.508 38.8446 190.712Z",
    fill: "#FF7C40"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6086 187.841C43.6086 189.696 42.1046 191.2 40.2496 191.2C38.3946 191.2 36.8906 189.696 36.8906 187.841C36.8906 185.986 38.3946 184.482 40.2496 184.482C42.1046 184.482 43.6086 185.986 43.6086 187.841Z",
    fill: "#FF9D6F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6086 188.065C43.6086 188.065 43.7136 191.236 42.9806 191.915C42.2476 192.594 41.0576 191.473 39.2586 191.051C37.4596 190.589 40.7166 187.09 40.7166 187.09L43.6086 188.065Z",
    fill: "#FF9D6F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8381 193.485L41.9621 192.995C41.9621 192.995 39.7201 192.785 38.9141 192.259L38.4941 192.855C38.4941 192.855 39.0541 193.941 40.4911 194.081C41.9281 194.221 42.5931 193.66 42.5931 193.66L42.8381 193.485Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2734 196.845L52.9854 196.548C52.9854 196.548 53.9154 196.904 53.6784 197.973L53.0644 198.369L52.2734 196.845Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8385 193.485C42.8385 193.485 44.3955 194.45 44.9885 194.886C45.5825 195.321 47.0865 198.924 47.0865 198.924L52.4305 196.668C52.4305 196.668 53.5385 197.42 53.1825 198.449C53.1825 198.449 48.1555 201.734 46.8885 201.972C45.6215 202.209 42.6135 197.222 42.6135 197.222C42.6135 197.222 40.9255 195.923 42.8385 193.485Z",
    fill: "#047CFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6207 184.706C42.6207 184.706 43.8427 185.792 43.6387 187.013C43.4347 188.235 41.8067 188.574 41.7387 189.863C41.6707 191.152 42.8667 191.578 41.9637 192.994C41.0607 194.41 41.8067 195.292 40.5177 196.514C39.2287 197.736 36.3107 197.261 35.9707 195.36C35.6317 193.46 36.7847 192.985 36.7167 191.627C36.6487 190.27 35.4957 188.438 36.3097 187.148C37.1237 185.859 37.2597 184.976 38.1417 184.569C39.0237 184.163 40.8567 183.484 42.6207 184.706Z",
    fill: "url(#paint36_linear_161_21105)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M242.529 191.319C242.673 193.464 241.05 195.319 238.906 195.462C236.761 195.606 234.906 193.983 234.763 191.839C234.62 189.694 236.242 187.84 238.386 187.696C240.53 187.552 242.385 189.174 242.529 191.319Z",
    fill: "url(#paint37_radial_161_21105)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M262.739 180.004C262.819 181.199 261.915 182.233 260.719 182.313C259.524 182.393 258.489 181.489 258.409 180.293C258.329 179.098 259.233 178.063 260.429 177.983C261.625 177.904 262.659 178.808 262.739 180.004Z",
    fill: "url(#paint38_radial_161_21105)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M231.343 170.129C231.423 171.324 230.519 172.358 229.323 172.438C228.127 172.518 227.093 171.614 227.013 170.418C226.933 169.223 227.837 168.188 229.033 168.108C230.229 168.029 231.263 168.933 231.343 170.129Z",
    fill: "url(#paint39_radial_161_21105)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20703 57.1304C1.87503 58.4764 -0.0079746 61.7374 2.53971e-05 64.4174L0.151023 117.826C0.158023 120.506 2.05302 121.586 4.38602 120.239L82.554 75.1094C84.886 73.7634 86.768 70.5024 86.761 67.8224L86.61 14.4134C86.602 11.7334 84.708 10.6534 82.375 12.0004L4.20703 57.1304Z",
    fill: "url(#paint40_linear_161_21105)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9445 36.5635C69.1455 32.4065 75.9615 33.4665 78.7775 40.0185C82.3015 48.2095 78.2945 62.0085 69.8105 71.5515L67.8425 66.9695C73.5895 60.2645 76.2665 50.7875 73.8275 45.1235C71.8405 40.5045 67.0375 39.7585 61.9615 42.6895C60.7235 43.4035 59.4705 44.3365 58.2375 45.4855L56.2695 40.9035C58.1445 39.1015 60.0585 37.6525 61.9445 36.5635Z",
    fill: "#F1F1F1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2694 40.9025L58.2354 45.4805C57.9254 45.7695 57.6154 46.0725 57.3094 46.3895C50.7774 53.1205 47.5864 63.4595 50.1784 69.4905C50.2744 69.7055 50.3744 69.9145 50.4824 70.1185C50.5194 70.1925 50.5614 70.2625 50.6024 70.3335C52.4924 73.6595 56.1114 74.4725 60.1244 72.8625C60.7504 72.6135 61.3884 72.3015 62.0314 71.9295C62.2034 71.8305 62.3744 71.7275 62.5464 71.6205C62.8604 71.4255 63.0994 71.2635 63.3344 71.1035L63.4414 71.0275C63.9574 70.6635 64.4684 70.2685 64.9844 69.8285C65.0464 69.7745 65.1124 69.7165 65.1784 69.6595C65.3684 69.4925 65.5574 69.3215 65.7474 69.1455C65.8174 69.0815 65.8874 69.0175 65.9584 68.9485C66.2054 68.7155 66.4524 68.4725 66.6964 68.2235C67.0924 67.8145 67.4714 67.3965 67.8424 66.9685L69.8104 71.5505C69.4354 71.9715 69.0564 72.3895 68.6654 72.7915C68.3154 73.1505 67.9644 73.4955 67.6104 73.8285C67.5114 73.9235 67.4124 74.0185 67.3094 74.1115C67.0414 74.3615 66.7694 74.6035 66.4974 74.8415C66.4064 74.9225 66.3164 75.0035 66.2254 75.0795C65.4954 75.7005 64.7614 76.2715 64.0314 76.7835C63.9734 76.8265 63.9154 76.8645 63.8584 76.9025C63.5244 77.1385 63.1894 77.3545 62.8594 77.5645L62.7444 77.6355C62.5164 77.7765 62.2894 77.9125 62.0634 78.0435C61.5234 78.3555 60.9854 78.6385 60.4504 78.8935C60.0464 79.0845 59.6654 79.2465 59.2864 79.3995C53.1634 81.8275 47.6824 80.2955 45.2314 74.5905C41.5534 66.0365 46.0834 51.3615 55.3444 41.8165C55.6514 41.5015 55.9604 41.1975 56.2694 40.9025Z",
    fill: "url(#paint41_linear_161_21105)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M102.691 34.8214L102.687 36.2224C102.684 37.0484 101.789 37.5624 101.075 37.1484L94.4647 33.3134C94.1327 33.1204 93.9287 32.7654 93.9297 32.3824L93.9337 30.9814C93.9357 30.1554 94.8307 29.6414 95.5457 30.0564L102.156 33.8914C102.489 34.0824 102.692 34.4384 102.691 34.8214Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M123.6 53.8583L123.596 55.2633C123.593 56.0883 122.7 56.6013 121.986 56.1893L94.4471 40.2893C94.1141 40.0973 93.9092 39.7413 93.9102 39.3563L93.9142 37.9523C93.9162 37.1273 94.8102 36.6133 95.5242 37.0263L123.063 52.9263C123.396 53.1183 123.601 53.4743 123.6 53.8583Z",
    fill: "white"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.207 61.2574L112.203 62.6614C112.201 63.4864 111.307 64.0004 110.593 63.5874L94.4081 54.2434C94.0751 54.0514 93.8701 53.6954 93.8711 53.3104L93.8751 51.9064C93.8771 51.0814 94.7711 50.5674 95.4851 50.9804L111.67 60.3254C112.004 60.5164 112.208 60.8724 112.207 61.2574Z",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M119.311 58.3704L119.307 59.7744C119.305 60.5994 118.412 61.1134 117.697 60.7014L94.4276 47.2674C94.0946 47.0744 93.8896 46.7194 93.8906 46.3344L93.8946 44.9294C93.8966 44.1044 94.7906 43.5904 95.5046 44.0034L118.774 57.4374C119.107 57.6304 119.312 57.9854 119.311 58.3704Z",
    fill: "#31C178"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M104.078 115.333L78.0246 130.474L78.0156 134.971L103.506 120.158C103.861 119.952 104.079 119.573 104.079 119.163V115.333H104.078Z",
    fill: "url(#paint42_linear_161_21105)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8652 115.333V119.208C51.8652 119.619 52.0842 119.999 52.4412 120.205L78.0162 134.971L78.0252 130.436L51.8652 115.333Z",
    fill: "url(#paint43_linear_161_21105)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M103.668 115.946L79.1415 130.199C78.4505 130.601 77.5965 130.602 76.9045 130.202L52.2125 115.946C51.7555 115.682 51.7545 115.022 52.2105 114.756L76.5705 100.6C77.3645 100.139 78.3445 100.137 79.1395 100.596L103.666 114.756C104.124 115.02 104.125 115.68 103.668 115.946Z",
    fill: "#F2F8FD"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6892 116.095L78.9932 124.635C78.3752 124.994 77.6122 124.995 76.9932 124.638L62.1932 116.093C61.6192 115.761 61.6172 114.933 62.1912 114.6L76.9762 106.008C77.5392 105.681 78.2342 105.68 78.7982 106.005L93.6872 114.601C94.2612 114.933 94.2622 115.762 93.6892 116.095Z",
    fill: "url(#paint44_linear_161_21105)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M104.078 105.736L78.0246 120.877L78.0156 125.374L103.506 110.561C103.861 110.355 104.079 109.976 104.079 109.566V105.736H104.078Z",
    fill: "url(#paint45_linear_161_21105)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8652 105.736V109.611C51.8652 110.022 52.0842 110.403 52.4412 110.608L78.0162 125.374L78.0252 120.839L51.8652 105.736Z",
    fill: "url(#paint46_linear_161_21105)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M103.668 106.348L79.1415 120.601C78.4505 121.003 77.5965 121.004 76.9045 120.604L52.2125 106.348C51.7555 106.084 51.7545 105.424 52.2105 105.158L76.5705 91.0024C77.3645 90.5414 78.3445 90.5394 79.1395 90.9984L103.666 105.158C104.124 105.422 104.125 106.082 103.668 106.348Z",
    fill: "#F2F8FD"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6892 106.497L78.9932 115.037C78.3752 115.396 77.6122 115.397 76.9932 115.04L62.1932 106.495C61.6192 106.164 61.6172 105.335 62.1912 105.002L76.9762 96.4104C77.5392 96.0834 78.2342 96.0824 78.7982 96.4074L93.6872 105.003C94.2612 105.335 94.2622 106.164 93.6892 106.497Z",
    fill: "url(#paint47_linear_161_21105)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0072 87.8725C12.6782 87.4855 13.2262 87.7975 13.2282 88.5685L13.2552 98.0745L8.14419 101.025L8.11719 91.5195C8.11519 90.7495 8.65919 89.8055 9.33019 89.4185L12.0072 87.8725Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2631 77.0854C20.9331 76.6984 21.4811 77.0054 21.4841 77.7814L21.5281 93.2984L16.4171 96.2494L16.3731 80.7324C16.3711 79.9564 16.9151 79.0184 17.5861 78.6314L20.2631 77.0854Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5266 69.2324C29.2016 68.8424 29.7446 69.1574 29.7476 69.9284L29.8006 88.5225L24.6936 91.4705L24.6406 72.8765C24.6386 72.1065 25.1786 71.1655 25.8536 70.7765L28.5266 69.2324Z",
    fill: "url(#paint48_linear_161_21105)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7963 61.5145C37.4673 61.1275 38.0143 61.4395 38.0173 62.2105L38.0783 83.7434L32.9673 86.6944L32.9063 65.1614C32.9043 64.3914 33.4483 63.4474 34.1193 63.0604L36.7963 61.5145Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8268 69.7214C82.8268 69.7214 85.0948 71.0284 85.4438 77.0074C85.1538 78.1104 83.4118 78.6904 82.0768 77.8204C80.7418 76.9485 82.1258 70.7364 82.8268 69.7214Z",
    fill: "url(#paint49_linear_161_21105)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2947 76.1775C71.2947 76.1775 66.0997 73.8635 65.4017 73.4705C64.7037 73.0775 64.1797 71.6375 63.9177 71.3315C63.6557 71.0255 62.4767 70.3275 62.5207 70.6325C62.5647 70.9385 63.1757 71.5055 63.1757 71.5055C63.1757 71.5055 62.7387 72.2475 62.6517 72.7275C62.5647 73.2075 63.2197 74.1685 63.5687 74.4295C63.9177 74.6905 64.7477 74.7785 64.7477 74.7785C64.7477 74.7785 68.9827 77.6165 69.6807 77.6595C70.3777 77.7045 71.3817 77.3125 71.2947 76.1775Z",
    fill: "#FF9D6F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8671 104.475C81.8671 104.475 82.0021 105.464 81.8221 105.869C81.6421 106.229 80.9231 106.499 80.4281 106.139C79.9331 105.779 79.0791 104.88 79.0791 104.88C79.0791 104.88 77.6401 104.116 77.5051 103.711C77.3701 103.306 77.8651 102.947 78.2701 103.036C78.6751 103.126 79.8441 103.845 80.3841 103.845C80.9231 103.845 81.6871 103.98 81.8671 104.475Z",
    fill: "#113C7A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3507 83.4144C83.3507 83.4144 82.0927 104.187 81.9357 104.789C81.7787 105.391 80.1457 105.736 79.8437 104.78C79.6517 104.173 79.1777 84.9504 79.1777 84.9504L83.3507 83.4144Z",
    fill: "#113C7A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7057 105.711C77.7767 105.772 77.8157 105.86 77.8157 105.953C77.8187 106.239 77.8047 106.875 77.6437 107.123C77.4327 107.447 76.7717 107.79 76.0807 107.415C75.4977 107.099 73.7047 105.758 73.3407 105.462C73.1197 105.282 73.0217 105.059 72.9787 104.889C72.9397 104.735 73.0177 104.577 73.1627 104.512C73.4167 104.399 73.8517 104.258 74.2397 104.388C74.8337 104.588 75.5817 105.231 76.3897 105.196C76.9987 105.17 77.4957 105.53 77.7057 105.711Z",
    fill: "#113C7A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9277 83.6384C75.0187 82.7754 76.0517 82.4944 77.0027 82.7884C78.8187 82.6904 81.6297 82.7684 81.7277 84.1774C81.8737 86.2634 80.8957 87.7524 79.9527 88.7654C79.2557 89.5134 78.7917 90.9454 78.5967 91.6424C78.4317 97.1514 78.0667 104.92 77.8387 105.664C77.4717 106.862 75.6647 106.808 75.5827 105.641C75.2167 101.699 74.9277 83.6384 74.9277 83.6384Z",
    fill: "#113C7A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9237 84.2885C75.1367 85.3545 78.1747 85.8875 79.9517 85.6035C81.7277 85.3195 83.6417 84.4475 83.5777 82.3885C83.5777 82.3885 83.8477 74.1585 83.8477 72.5395C83.8477 70.9205 82.8297 69.7215 82.8297 69.7215C82.8297 69.7215 81.8347 68.5845 78.7077 69.2245C78.7077 69.2245 76.1607 69.7795 74.9877 71.6625C74.9877 71.6625 74.1777 73.7315 74.4477 78.0485C74.7177 82.3655 74.9237 84.2885 74.9237 84.2885Z",
    fill: "url(#paint50_linear_161_21105)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1474 66.9394C81.1474 66.9394 80.8774 68.5135 81.1474 69.2335C81.1924 69.5935 79.6184 70.8075 78.2244 70.4925C77.4144 70.3125 77.4594 69.9074 77.4594 69.9074C77.4594 69.9074 78.1344 68.7835 78.0444 67.7035C77.9544 66.6245 80.2034 66.7144 81.1474 66.9394Z",
    fill: "#FF7C40"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8867 63.7685C75.8867 65.8175 77.5477 67.4785 79.5967 67.4785C81.6457 67.4785 83.3067 65.8175 83.3067 63.7685C83.3067 61.7195 81.6457 60.0585 79.5967 60.0585C77.5477 60.0585 75.8867 61.7195 75.8867 63.7685Z",
    fill: "#FF9D6F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8872 64.0164C75.8872 64.0164 75.8422 67.7334 76.6522 68.4834C77.4612 69.2334 78.7042 67.7814 80.6912 67.3154C82.6782 66.8044 79.0802 62.9404 79.0802 62.9404L75.8872 64.0164Z",
    fill: "#FF9D6F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1854 70.7955C76.1854 70.7955 75.3724 70.5635 74.4434 71.8985C73.5144 73.2335 72.1794 74.9755 71.5414 75.2655C70.9024 75.5555 70.0324 74.9755 69.6834 74.9755C69.3354 74.9755 68.4064 76.6005 68.7544 77.4135C69.1024 78.2265 71.3664 78.6325 71.9474 78.6325C72.5284 78.6325 76.3014 76.3685 76.8234 75.0915C77.3464 73.8145 78.1594 70.8535 76.1854 70.7955Z",
    fill: "url(#paint51_linear_161_21105)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2071 75.1495C70.2071 75.1495 69.9751 74.5105 69.1621 74.4525C68.3491 74.3945 67.4212 75.9615 67.4792 76.8325C67.5372 77.7035 68.8142 78.1675 69.1042 77.9355C69.3942 77.7035 68.8141 77.1225 70.2071 75.1495Z",
    fill: "url(#paint52_linear_161_21105)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3748 60.6365C77.3748 60.6365 76.0398 60.9265 75.6328 62.9585C75.8068 63.8295 77.0258 63.1325 77.4908 64.2935C77.9548 65.4545 78.2458 65.8025 78.2458 65.8025L78.5358 65.6865C78.5358 65.6865 78.5358 64.7575 78.9418 64.7575C79.3478 64.7575 79.4638 65.8605 79.2318 66.3245C78.9998 66.7885 78.4768 67.0214 78.4768 67.0214C78.4768 67.0214 79.0568 68.0084 79.3478 68.1244C79.6378 68.2404 80.6828 68.0085 81.0898 67.8345C81.4958 67.6605 82.2508 66.8475 82.8318 65.9185C83.4118 64.9895 83.9348 63.3645 83.5868 62.2615C83.2388 61.1585 82.4258 60.8684 82.4258 60.8684C82.4258 60.8684 81.9618 60.2294 81.1488 59.9394C80.3358 59.6504 78.8268 59.5335 77.3748 60.6365Z",
    fill: "#5167B0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7383 70.0025L77.7053 69.4605C77.7053 69.4605 80.1823 69.2285 81.0723 68.6475L81.5363 69.3055C81.5363 69.3055 80.9173 70.5055 79.3303 70.6595C77.7433 70.8145 77.0083 70.1955 77.0083 70.1955L76.7383 70.0025Z",
    fill: "#CFDAE4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M149.858 270.305L136.284 278.194L136.279 280.537L149.56 272.819C149.745 272.712 149.858 272.514 149.858 272.301V270.305Z",
    fill: "url(#paint53_linear_161_21105)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M122.654 270.305V272.324C122.654 272.538 122.768 272.736 122.954 272.844L136.279 280.537L136.284 278.174L122.654 270.305Z",
    fill: "url(#paint54_linear_161_21105)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M149.644 270.624L136.866 278.05C136.506 278.259 136.061 278.26 135.7 278.052L122.835 270.625C122.597 270.487 122.596 270.143 122.834 270.005L135.526 262.629C135.94 262.389 136.45 262.388 136.865 262.627L149.643 270.005C149.881 270.142 149.882 270.485 149.644 270.624Z",
    fill: "#F2F8FD"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M144.445 270.701L136.788 275.15C136.466 275.337 136.068 275.338 135.746 275.152L128.035 270.7C127.736 270.527 127.735 270.095 128.034 269.922L135.737 265.445C136.03 265.274 136.393 265.274 136.686 265.444L144.443 269.923C144.743 270.096 144.743 270.528 144.445 270.701Z",
    fill: "url(#paint55_linear_161_21105)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M169.858 282.971L156.284 290.859L156.279 293.202L169.56 285.484C169.745 285.377 169.858 285.179 169.858 284.966V282.971Z",
    fill: "url(#paint56_linear_161_21105)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M142.654 282.971V284.99C142.654 285.204 142.768 285.402 142.954 285.51L156.279 293.203L156.284 290.841L142.654 282.971Z",
    fill: "url(#paint57_linear_161_21105)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M169.644 283.29L156.866 290.716C156.506 290.925 156.061 290.926 155.7 290.718L142.835 283.291C142.597 283.153 142.596 282.809 142.834 282.671L155.526 275.295C155.94 275.055 156.45 275.054 156.865 275.293L169.643 282.671C169.881 282.808 169.882 283.152 169.644 283.29Z",
    fill: "#F2F8FD"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M164.445 283.368L156.788 287.818C156.466 288.005 156.068 288.006 155.746 287.819L148.035 283.367C147.736 283.194 147.735 282.763 148.034 282.589L155.737 278.112C156.03 277.942 156.393 277.941 156.686 278.111L164.443 282.59C164.743 282.763 164.743 283.194 164.445 283.368Z",
    fill: "url(#paint58_linear_161_21105)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.0815 266.624L65.3715 279.822C64.4165 280.377 63.2375 280.379 62.2815 279.826L39.4105 266.621C38.5235 266.109 38.5215 264.828 39.4075 264.313L62.2545 251.036C63.1245 250.53 64.1985 250.529 65.0695 251.032L88.0775 264.316C88.9665 264.829 88.9685 266.109 88.0815 266.624Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.082 313.624L185.372 326.822C184.417 327.377 183.238 327.379 182.282 326.826L159.411 313.621C158.524 313.109 158.522 311.828 159.408 311.313L182.255 298.036C183.125 297.53 184.199 297.529 185.071 298.032L208.079 311.316C208.967 311.829 208.969 313.109 208.082 313.624Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.373 260.106L367.655 267.497C367.12 267.808 366.46 267.809 365.924 267.5L353.116 260.105C352.619 259.818 352.618 259.101 353.114 258.813L365.909 251.377C366.396 251.094 366.998 251.093 367.486 251.375L380.371 258.814C380.869 259.101 380.87 259.818 380.373 260.106Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M307.718 320.439C307.55 323.486 305.399 325.945 302.991 327.604C300.076 329.613 296.579 330.754 293.108 331.327C286.221 332.464 278.211 331.708 272.246 327.819C269.563 326.07 267.095 323.349 267.105 319.964C267.098 322.328 267.025 319.731 267.087 322.094C267.23 327.569 273.07 330.812 277.639 332.282C283.251 334.087 289.568 334.239 295.288 332.841C300.051 331.677 306.196 328.974 307.504 323.694C307.855 322.279 307.717 320.719 307.721 319.274C307.725 317.886 307.729 321.468 307.733 320.08C307.732 320.2 307.726 320.32 307.718 320.439Z",
    fill: "url(#paint59_linear_161_21105)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M301.739 311.704C309.697 316.298 309.739 323.748 301.828 328.345C293.922 332.94 281.061 332.94 273.104 328.345C265.146 323.751 265.1 316.299 273.006 311.704C280.917 307.107 293.782 307.11 301.739 311.704ZM275.769 326.796C282.247 330.536 292.714 330.534 299.145 326.796C305.581 323.056 305.552 316.993 299.073 313.253C292.595 309.513 282.124 309.513 275.688 313.253C269.257 316.991 269.291 323.056 275.769 326.796Z",
    fill: "#DCDCDC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M301.739 311.704C309.697 316.298 309.739 323.748 301.828 328.345C293.922 332.94 281.061 332.94 273.104 328.345C265.146 323.751 265.1 316.299 273.006 311.704C280.917 307.107 293.782 307.11 301.739 311.704Z",
    fill: "url(#paint60_linear_161_21105)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M301.674 319.489C301.722 319.243 301.747 318.992 301.746 318.74C301.745 318.497 301.72 318.257 301.674 318.02V246.295H273.139V319.49H273.202C273.868 323.216 280.002 326.12 287.465 326.097C294.87 326.073 300.951 323.177 301.674 319.489Z",
    fill: "url(#paint61_linear_161_21105)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M347.385 299.772C347.217 302.819 345.066 305.278 342.658 306.937C339.743 308.946 336.246 310.087 332.775 310.66C325.888 311.798 317.878 311.041 311.912 307.153C309.229 305.405 306.762 302.683 306.771 299.297C306.764 301.661 306.691 299.064 306.753 301.427C306.896 306.902 312.736 310.145 317.305 311.615C322.917 313.42 329.234 313.572 334.954 312.174C339.717 311.01 345.862 308.307 347.17 303.027C347.521 301.612 347.383 300.052 347.387 298.607C347.391 297.219 347.395 300.801 347.399 299.413C347.398 299.534 347.393 299.653 347.385 299.772Z",
    fill: "url(#paint62_linear_161_21105)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M341.405 291.038C349.363 295.632 349.405 303.082 341.494 307.679C333.588 312.273 320.727 312.274 312.77 307.679C304.812 303.085 304.766 295.633 312.672 291.038C320.582 286.441 333.447 286.443 341.405 291.038ZM315.435 306.13C321.913 309.87 332.379 309.868 338.811 306.13C345.247 302.39 345.218 296.327 338.739 292.587C332.261 288.847 321.79 288.847 315.354 292.587C308.922 296.324 308.957 302.389 315.435 306.13Z",
    fill: "#DCDCDC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M341.405 291.038C349.363 295.632 349.405 303.082 341.494 307.679C333.588 312.273 320.727 312.274 312.77 307.679C304.812 303.085 304.766 295.633 312.672 291.038C320.582 286.441 333.447 286.443 341.405 291.038Z",
    fill: "#2689FD"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M341.674 298.989C341.722 298.743 341.747 298.492 341.746 298.24C341.745 297.997 341.72 297.757 341.674 297.52V225.795H313.139V298.99H313.202C313.868 302.716 320.002 305.62 327.465 305.597C334.87 305.573 340.951 302.677 341.674 298.989Z",
    fill: "url(#paint63_linear_161_21105)"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.559 260.446L248.962 313.677C245.11 315.915 240.355 315.922 236.497 313.695L144.25 260.436C140.67 258.369 140.663 253.205 144.237 251.128L236.388 197.575C239.897 195.536 244.229 195.53 247.744 197.559L340.546 251.138C344.126 253.204 344.133 258.368 340.559 260.446Z",
    fill: "black",
    fillOpacity: 0.25
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M279.696 205.106L279.579 223.837L269.153 232.933H259.846V212.178L279.696 205.106Z",
    fill: "#2689FD"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M279.58 221.949L279.501 248.432L261.844 258.693L261.923 231.527L279.58 221.949Z",
    fill: "#BB4F23"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M257.997 213.429C256.9 212.996 255.646 212.556 254.478 212.223C253.523 211.951 252.547 211.712 251.555 211.507C250.641 211.318 249.714 211.157 248.777 211.024C247.877 210.896 246.967 210.795 246.053 210.72C245.137 210.644 244.216 210.595 243.293 210.572C242.337 210.548 241.379 210.553 240.424 210.585C239.384 210.621 238.346 210.689 237.317 210.792C236.112 210.912 234.919 211.078 233.745 211.29C231.92 211.619 230.142 212.059 228.443 212.61C226.242 213.324 224.174 214.223 222.306 215.309C222.191 215.376 222.077 215.443 221.964 215.511C220.603 216.329 219.421 217.21 218.417 218.137C217.762 218.742 217.183 219.366 216.68 220.005C216.249 220.553 215.873 221.112 215.552 221.679C215.256 222.204 215.007 222.735 214.806 223.272C214.61 223.794 214.459 224.321 214.353 224.85C214.246 225.384 214.185 225.921 214.169 226.458C214.167 226.54 214.165 226.622 214.165 226.704L214.086 254.553C214.086 254.471 214.087 254.389 214.09 254.307C214.106 253.77 214.167 253.233 214.274 252.699C214.38 252.17 214.531 251.643 214.727 251.122C214.928 250.585 215.177 250.054 215.473 249.529C215.793 248.962 216.169 248.403 216.6 247.855C217.104 247.216 217.683 246.591 218.338 245.987C219.342 245.06 220.525 244.179 221.885 243.361C221.998 243.293 222.112 243.226 222.227 243.159C224.095 242.073 226.164 241.174 228.364 240.46C230.063 239.909 231.841 239.469 233.666 239.14C234.84 238.928 236.034 238.762 237.238 238.643C238.267 238.54 239.304 238.471 240.345 238.436C241.3 238.403 242.258 238.399 243.214 238.423C244.136 238.446 245.058 238.495 245.973 238.571C246.887 238.646 247.797 238.748 248.697 238.875C249.634 239.008 250.561 239.169 251.475 239.358C252.467 239.563 253.443 239.802 254.398 240.074C255.567 240.407 256.704 240.79 257.801 241.223C259.224 241.785 260.623 242.464 261.888 243.194L262.04 215.369C260.775 214.637 259.42 213.991 257.997 213.429Z",
    fill: "url(#paint64_linear_161_21105)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 242.397L270.114 254.712C270.126 250.533 267.367 261.883 261.844 258.694L261.923 231.528C267.446 234.716 270.205 238.218 270.193 242.397Z",
    fill: "#1E079D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_161_21105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 231,
    width: 10,
    height: 29
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 242.397L270.114 254.712C270.126 250.533 267.367 261.883 261.844 258.694L261.923 231.528C267.446 234.716 270.205 238.218 270.193 242.397Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_161_21105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.193 242.397L270.114 254.712C270.126 250.533 267.367 261.883 261.844 258.694L261.923 230.845C267.446 234.033 270.205 238.218 270.193 242.397Z",
    fill: "url(#paint65_linear_161_21105)"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M295.239 242.934C295.21 243.951 295.094 244.967 294.891 245.978C294.69 246.98 294.404 247.977 294.034 248.965C293.653 249.981 293.182 250.988 292.621 251.982C292.014 253.056 291.302 254.115 290.486 255.153C289.532 256.364 288.435 257.547 287.195 258.692C285.292 260.449 283.052 262.118 280.474 263.668C280.26 263.796 280.018 263.941 279.8 264.068L279.746 276.366C279.964 276.239 280.18 276.112 280.394 275.983C282.972 274.433 285.212 272.764 287.115 271.007C288.355 269.862 289.452 268.679 290.406 267.468C291.223 266.43 291.935 265.372 292.541 264.297C293.102 263.304 293.573 262.297 293.954 261.28C294.325 260.292 294.611 259.295 294.811 258.293C295.013 257.282 295.129 256.266 295.159 255.249C295.164 255.094 295.166 254.938 295.166 254.783L295.245 242.468C295.246 242.624 295.243 242.779 295.239 242.934Z",
    fill: "url(#paint66_linear_161_21105)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M279.58 221.949C300.372 233.953 300.455 252.064 279.798 264.068L262.051 253.789C272.956 247.452 272.898 237.864 261.922 231.527L279.58 221.949Z",
    fill: "url(#paint67_linear_161_21105)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M279.825 257.939L279.746 276.366L261.973 266.104L262.052 263.212L279.825 257.939Z",
    fill: "#88630A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_161_21105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 257,
    width: 38,
    height: 29
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M279.823 257.939L279.744 276.366C269.416 282.368 255.853 285.373 242.273 285.371L242.352 266.944C255.932 266.946 269.495 263.941 279.823 257.939Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_161_21105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.962 263.128C264.808 264.139 261.512 264.949 258.131 265.559C255.905 265.96 253.641 266.274 251.357 266.501C249.415 266.694 247.457 266.824 245.494 266.89C244.448 266.925 243.4 266.943 242.352 266.943L242.273 285.37C243.321 285.37 244.368 285.352 245.414 285.317C247.377 285.25 249.335 285.12 251.277 284.928C253.562 284.701 255.825 284.387 258.052 283.986C261.433 283.377 264.729 282.567 267.883 281.556C272.14 280.192 276.139 278.462 279.744 276.367L279.823 257.94C276.218 260.034 272.219 261.764 267.962 263.128Z",
    fill: "url(#paint68_linear_161_21105)"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M242.352 266.943L242.273 285.37L242.191 270.857L242.27 252.43L242.352 266.943Z",
    fill: "#113C7A"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M279.824 257.939C269.496 263.941 255.933 266.946 242.353 266.944L242.271 252.431C249.437 252.431 256.599 250.847 262.051 247.678L279.824 257.939Z",
    fill: "url(#paint69_linear_161_21105)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_161_21105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 226,
    width: 54,
    height: 60
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M189.031 254.48L189.11 226.631C189.088 234.549 194.313 242.479 204.776 248.519C215.172 254.521 228.769 257.521 242.353 257.521L242.274 285.37C228.69 285.37 215.093 282.37 204.697 276.368C194.234 270.328 189.009 262.398 189.031 254.48Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_161_21105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.046 257.492C238.302 257.448 236.56 257.355 234.828 257.212C233.098 257.07 231.377 256.877 229.673 256.636C227.907 256.386 226.159 256.083 224.435 255.726C222.55 255.336 220.694 254.883 218.879 254.366C216.683 253.74 214.546 253.022 212.485 252.21C209.77 251.141 207.187 249.91 204.776 248.519C194.313 242.478 189.088 234.549 189.11 226.631L189.031 254.48C189.009 262.398 194.234 270.328 204.697 276.368C207.108 277.76 209.691 278.991 212.406 280.06C214.467 280.871 216.605 281.59 218.8 282.215C220.615 282.732 222.471 283.186 224.356 283.576C226.079 283.932 227.828 284.236 229.594 284.486C231.298 284.728 233.018 284.92 234.749 285.062C236.481 285.205 238.223 285.298 239.967 285.341C240.736 285.36 241.505 285.37 242.274 285.37L242.353 257.521C241.584 257.521 240.815 257.511 240.046 257.492Z",
    fill: "url(#paint70_linear_161_21105)"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M279.696 205.106L262.039 215.367C251.063 209.03 233.209 208.97 222.305 215.307C211.4 221.644 211.458 231.92 222.434 238.258C227.922 241.426 235.101 243.011 242.272 243.008L242.354 257.521C228.77 257.521 215.173 254.521 204.777 248.519C183.985 236.515 183.876 217.05 204.532 205.046C225.188 193.042 258.904 193.102 279.696 205.106Z",
    fill: "url(#paint71_linear_161_21105)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M270.614 244.421C270.703 243.968 270.748 243.508 270.746 243.043C270.745 242.596 270.698 242.155 270.614 241.72V109.819H218.139V244.421H218.255C219.48 251.273 230.76 256.613 244.484 256.571C258.101 256.529 269.285 251.204 270.614 244.421Z",
    fill: "url(#paint72_linear_161_21105)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M249.811 173.408L252.646 171.761L252.592 191.009L249.756 192.657L249.811 173.408Z",
    fill: "#00A935"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M255.6 172.894C255.6 172.886 255.6 172.879 255.6 172.871C255.6 172.863 255.599 172.855 255.599 172.848C255.598 172.84 255.598 172.832 255.597 172.824C255.596 172.816 255.596 172.809 255.595 172.801C255.594 172.793 255.593 172.785 255.591 172.777C255.59 172.769 255.588 172.761 255.587 172.752C255.585 172.744 255.584 172.735 255.582 172.727C255.582 172.725 255.581 172.723 255.581 172.721C255.58 172.715 255.578 172.708 255.577 172.702C255.575 172.694 255.573 172.685 255.57 172.677C255.568 172.668 255.565 172.66 255.562 172.651C255.559 172.643 255.557 172.634 255.554 172.625C255.551 172.617 255.548 172.609 255.546 172.601C255.543 172.593 255.54 172.585 255.537 172.576C255.534 172.568 255.53 172.56 255.527 172.551C255.523 172.543 255.52 172.534 255.516 172.526C255.512 172.518 255.508 172.509 255.504 172.501C255.5 172.493 255.496 172.484 255.492 172.475V172.474L246.666 154.903C246.662 154.896 246.658 154.889 246.655 154.882C246.647 154.868 246.639 154.853 246.631 154.839C246.617 154.815 246.603 154.793 246.588 154.77C246.579 154.756 246.569 154.743 246.56 154.73C246.553 154.721 246.546 154.712 246.539 154.703C246.533 154.695 246.526 154.687 246.52 154.679C246.514 154.672 246.508 154.664 246.501 154.657C246.498 154.653 246.494 154.649 246.491 154.646L246.49 154.645C246.487 154.642 246.485 154.639 246.482 154.636C246.475 154.629 246.469 154.622 246.462 154.615C246.455 154.608 246.448 154.601 246.441 154.594C246.434 154.587 246.426 154.58 246.419 154.573C246.411 154.566 246.404 154.56 246.396 154.553C246.389 154.547 246.381 154.541 246.374 154.535C246.366 154.529 246.359 154.524 246.352 154.518C246.345 154.513 246.337 154.508 246.33 154.503C246.323 154.498 246.316 154.493 246.309 154.489C246.302 154.484 246.295 154.48 246.288 154.476C246.286 154.475 246.285 154.474 246.283 154.473C246.278 154.47 246.272 154.467 246.267 154.464C246.26 154.46 246.253 154.457 246.246 154.453C246.239 154.449 246.233 154.446 246.226 154.443C246.219 154.44 246.213 154.437 246.206 154.435C246.199 154.432 246.193 154.43 246.186 154.427C246.179 154.425 246.172 154.422 246.166 154.42C246.159 154.418 246.152 154.416 246.145 154.414C246.138 154.412 246.131 154.411 246.124 154.409C246.117 154.407 246.11 154.406 246.102 154.405C246.099 154.405 246.097 154.404 246.094 154.404H246.093C246.088 154.404 246.084 154.403 246.08 154.403C246.072 154.403 246.064 154.402 246.057 154.402C246.048 154.402 246.04 154.402 246.032 154.403C246.022 154.404 246.013 154.405 246.004 154.407C245.992 154.409 245.981 154.412 245.97 154.416C245.956 154.421 245.942 154.427 245.929 154.435L243.094 156.083C243.143 156.055 243.199 156.045 243.26 156.052H243.261C243.322 156.059 243.386 156.082 243.45 156.119C243.521 156.16 243.592 156.218 243.658 156.291L243.659 156.292C243.725 156.365 243.785 156.451 243.835 156.549L252.661 174.12C252.704 174.206 252.733 174.289 252.751 174.367V174.368C252.768 174.446 252.774 174.518 252.769 174.583V174.584C252.764 174.648 252.749 174.704 252.724 174.751C252.723 174.752 252.723 174.753 252.722 174.754C252.697 174.8 252.664 174.837 252.623 174.861L255.458 173.213C255.492 173.193 255.521 173.165 255.544 173.13C255.549 173.123 255.553 173.115 255.557 173.107C255.558 173.106 255.558 173.105 255.559 173.103C255.56 173.1 255.562 173.098 255.564 173.095C255.569 173.085 255.573 173.075 255.577 173.064C255.58 173.056 255.583 173.047 255.586 173.038C255.589 173.029 255.591 173.02 255.593 173.011C255.595 173.003 255.596 172.995 255.598 172.987C255.599 172.979 255.601 172.971 255.602 172.962C255.603 172.955 255.604 172.947 255.604 172.939C255.604 172.939 255.604 172.937 255.604 172.935C255.604 172.929 255.605 172.922 255.605 172.915C255.6 172.91 255.6 172.902 255.6 172.894Z",
    fill: "#61E041"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M243.444 156.12C243.586 156.202 243.729 156.354 243.829 156.55L252.655 174.121C252.916 174.644 252.683 175.066 252.267 174.825L249.812 173.407L249.757 192.656L236.863 185.212L236.918 165.963L234.545 164.593C234.124 164.35 233.894 163.662 234.162 163.444L243.058 156.105C243.158 156.025 243.301 156.038 243.444 156.12Z",
    fill: "#00CC41"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M319.596 204.774L319.961 204.455L320.827 202.86C320.827 202.86 321.009 203.042 321.055 203.27C321.101 203.498 320.964 204 320.964 204C320.964 204 322.97 203.909 322.97 204.046C322.97 204.183 322.879 205.14 322.697 205.231C322.515 205.322 320.737 205.322 320.737 205.322L320.19 205.55C320.19 205.55 319.916 205.458 319.596 204.774Z",
    fill: "#F5B697"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M304.22 240.305C308.959 240.305 312.801 237.864 312.801 234.853C312.801 231.842 308.959 229.401 304.22 229.401C299.481 229.401 295.639 231.842 295.639 234.853C295.639 237.864 299.481 240.305 304.22 240.305Z",
    fill: "#392836"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M302.077 232.244C302.077 232.244 301.691 232.887 300.877 233.315C300.063 233.744 299.592 234.172 299.592 234.515C299.592 234.858 300.106 235.029 300.835 234.986C301.563 234.943 301.992 234.129 302.506 233.915C303.02 233.701 303.62 233.658 303.792 233.401C303.963 233.144 303.792 232.116 303.792 232.116L302.077 232.244Z",
    fill: "#392836"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M307.456 234.129C307.456 234.129 307.392 234.729 307.049 234.986C306.706 235.243 306.449 235.672 305.892 235.886C305.335 236.1 304.992 236.572 304.992 236.872C304.992 237.172 306.192 237.386 306.877 237.129C307.563 236.872 308.291 235.929 308.591 235.801C308.891 235.673 309.105 235.33 309.148 235.115C309.191 234.901 309.019 234.087 309.019 234.087L307.456 234.129Z",
    fill: "#392836"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M311.025 213.52C311.025 213.52 310.811 216.544 310.453 218.542C310.095 220.54 309.575 233.725 309.132 234.246C308.689 234.766 308.046 234.711 307.459 234.141C306.872 233.571 306.321 217.315 306.321 217.315L304.533 213.612L311.025 213.52Z",
    fill: "#392836"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M302.635 212.018C302.635 212.018 301.777 228.216 301.863 231.987C301.863 233.101 303.577 233.272 304.006 232.158C304.434 231.044 306.234 215.189 306.063 213.132C305.89 211.075 302.892 210.561 302.635 212.018Z",
    fill: "#392836"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M308.413 198.142C308.413 198.142 311.756 200.53 312.086 201.325C312.417 202.119 312.487 204.33 311.798 205.804C311.109 207.278 311.361 212.701 311.113 213.762C310.865 214.823 308.004 215.158 306.234 214.815C304.464 214.473 302.323 213.192 302.389 211.128C302.456 209.064 302.412 205.215 302.299 204.285C302.187 203.355 302.309 201.02 302.741 199.454C302.832 199.124 303.944 198.777 303.944 198.777C303.944 198.777 305.118 198.003 308.413 198.142Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M305.507 197.692C305.507 197.692 305.516 197.734 305.506 197.8C305.469 198.045 305.347 198.671 305.325 198.933C305.303 199.184 305.588 199.618 306.265 199.605C306.942 199.591 308.091 199.308 308.474 198.501C308.443 198.358 308.491 196.863 308.587 196.118L305.507 197.692Z",
    fill: "#E0A082"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M308.481 198.183C308.481 198.183 308.808 199.452 308.465 200.224C308.122 200.995 305.765 207.562 305.765 207.562L305.594 215.104C305.594 215.104 309.493 216.475 311.336 214.59L311.722 207.005C311.722 207.005 312.493 203.577 312.493 201.52C312.493 201.52 312.252 200.797 308.481 198.183Z",
    fill: "#392836"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M305.208 198.349C305.208 198.349 304.552 199.293 304.48 200.706C304.223 205.72 305.808 207.862 305.808 207.862L305.851 215.233C305.851 215.233 303.237 215.019 302.123 213.09L301.844 202.923L302.422 199.324C302.422 199.324 303.623 198.66 305.208 198.349Z",
    fill: "#392836"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M303.811 192.845C304.199 190.773 305.84 189.598 307.696 190.032C307.696 190.032 309.708 190.234 310.602 192.001C311.496 193.768 310.183 195.254 309.342 196.191C308.987 196.576 308.72 196.873 308.551 197.062C308.49 197.133 308.43 197.206 308.366 197.271C308.354 197.284 308.348 197.291 308.348 197.291L308.346 197.289C307.772 197.863 307.113 198.188 306.626 198.333C305.817 198.574 304.859 198.436 304.343 197.885C303.826 197.335 303.423 194.917 303.811 192.845Z",
    fill: "#F5B697"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M306.495 200.321L306.838 201.306L306.324 201.863L306.623 208.419L304.781 208.034L305.724 201.863L305.595 200.706L306.152 200.235L306.495 200.321Z",
    fill: "#392836"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M302.425 199.324C302.425 199.324 299.083 204.241 298.697 205.527L295.676 202.634C295.676 202.634 294.905 202.506 294.391 203.47C293.877 204.434 294.391 204.756 294.391 204.756C294.391 204.756 298.055 208.613 298.89 208.613C299.726 208.613 303.132 203.471 303.132 203.278C303.132 203.085 302.425 199.324 302.425 199.324Z",
    fill: "#392836"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M295.482 202.956C295.482 202.956 295.611 203.759 294.453 204.37L294.035 204.017C294.035 204.017 294.067 203.246 295.031 202.667L295.482 202.956Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M294.702 202.68L294.355 202.294L294.176 200.728C294.176 200.728 293.829 200.728 293.713 200.959C293.597 201.19 293.623 201.715 293.623 201.715C293.623 201.715 291.81 200.057 291.695 200.134C291.579 200.211 291.618 200.52 291.618 200.52L292.929 201.831C292.929 201.831 292.659 202.718 292.736 203.027C292.813 203.336 293.16 203.567 293.353 203.644C293.546 203.721 294.047 203.567 294.047 203.567L294.548 203.953C294.548 203.953 295.011 203.606 295.204 203.143L294.702 202.68Z",
    fill: "#F5B697"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M312.102 201.057C312.102 201.057 315.444 205.974 315.83 207.26L318.851 204.367C318.851 204.367 319.622 204.239 320.136 205.203C320.65 206.167 320.136 206.488 320.136 206.488C320.136 206.488 316.472 210.345 315.637 210.345C314.801 210.345 311.395 205.203 311.395 205.01C311.395 204.817 312.102 201.057 312.102 201.057Z",
    fill: "#392836"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M319.043 204.688C319.043 204.688 318.914 205.491 320.071 206.102L320.489 205.749C320.489 205.749 320.457 204.978 319.493 204.399L319.043 204.688Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M307.951 194.086C307.951 194.086 307.949 194.182 307.937 194.343C307.887 194.999 307.659 196.728 306.633 197.314C305.357 197.983 304.566 197.861 304.019 197.132C304.019 197.132 303.594 197.983 303.837 198.408C304.08 198.833 306.147 198.833 306.937 198.347C307.727 197.861 308.274 195.065 308.274 195.065L308.396 194.457",
    fill: "#392836"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M309.977 190.414C309.977 190.414 308.852 188.986 307.272 189.168C305.692 189.35 304.993 189.047 303.807 189.472C302.622 189.897 303.26 191.994 304.597 192.511C305.934 193.028 307.727 192.754 307.94 192.967C308.153 193.18 307.849 195.429 307.849 195.429L308.183 195.49C308.183 195.49 308.578 194.67 309.004 194.791C309.429 194.913 309.004 196.463 308.578 196.432C308.365 196.432 308.365 196.432 308.365 196.432L308.487 197.465C308.487 197.465 309.855 196.097 310.402 195.246C310.949 194.395 311.678 193.423 311.192 192.602C310.706 191.782 311.101 190.992 309.977 190.414Z",
    fill: "#392836"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_21105",
    x1: 351.7,
    y1: 165.139,
    x2: 389.152,
    y2: 165.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_161_21105",
    x1: 351.701,
    y1: 172.382,
    x2: 383.766,
    y2: 172.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_161_21105",
    x1: 268.533,
    y1: 43.1635,
    x2: 268.533,
    y2: 156.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3144,
    stopColor: "#1493B7",
    stopOpacity: 0.6856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#285A72",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8795,
    stopColor: "#343647",
    stopOpacity: 0.1205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_161_21105",
    x1: 275.466,
    y1: 216.823,
    x2: 243.41,
    y2: -21.4093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_161_21105",
    x1: 337.777,
    y1: 150.795,
    x2: 324.946,
    y2: 150.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_161_21105",
    x1: 185.27,
    y1: 140.608,
    x2: 315.072,
    y2: 140.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_161_21105",
    x1: 205.951,
    y1: 25.4041,
    x2: 205.951,
    y2: 90.3924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_161_21105",
    x1: 260.348,
    y1: 94.6253,
    x2: 260.348,
    y2: 132.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_161_21105",
    x1: 294.349,
    y1: 122.014,
    x2: 318.215,
    y2: 122.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_161_21105",
    x1: 83.6025,
    y1: 209.845,
    x2: 83.6025,
    y2: 166.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_161_21105",
    x1: 32.4031,
    y1: 180.177,
    x2: 85.5067,
    y2: 207.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_161_21105",
    x1: 76.6547,
    y1: 147.93,
    x2: 59.5647,
    y2: 207.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_161_21105",
    x1: 79.7178,
    y1: 181.048,
    x2: 79.7178,
    y2: 111.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3144,
    stopColor: "#1493B7",
    stopOpacity: 0.6856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#285A72",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8795,
    stopColor: "#343647",
    stopOpacity: 0.1205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_161_21105",
    x1: 55.1647,
    y1: 188.303,
    x2: 55.1647,
    y2: 110.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#02C9F8",
    stopOpacity: 0.8957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#07BAE5",
    stopOpacity: 0.7465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4297,
    stopColor: "#10A0C6",
    stopOpacity: 0.5703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6265,
    stopColor: "#1C7C9B",
    stopOpacity: 0.3735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    stopColor: "#2C4F65",
    stopOpacity: 0.1623
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_161_21105",
    x1: 134.346,
    y1: 237.151,
    x2: 134.346,
    y2: 194.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_161_21105",
    x1: 83.1479,
    y1: 207.482,
    x2: 136.251,
    y2: 234.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_161_21105",
    x1: 127.398,
    y1: 175.235,
    x2: 110.309,
    y2: 234.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_161_21105",
    x1: 130.461,
    y1: 208.353,
    x2: 130.461,
    y2: 138.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3144,
    stopColor: "#1493B7",
    stopOpacity: 0.6856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#285A72",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8795,
    stopColor: "#343647",
    stopOpacity: 0.1205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_161_21105",
    x1: 105.908,
    y1: 215.608,
    x2: 105.908,
    y2: 138.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#02C9F8",
    stopOpacity: 0.8957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#07BAE5",
    stopOpacity: 0.7465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4297,
    stopColor: "#10A0C6",
    stopOpacity: 0.5703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6265,
    stopColor: "#1C7C9B",
    stopOpacity: 0.3735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    stopColor: "#2C4F65",
    stopOpacity: 0.1623
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_161_21105",
    x1: 132.526,
    y1: 183.321,
    x2: 132.526,
    y2: 140.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_161_21105",
    x1: 81.3268,
    y1: 153.652,
    x2: 134.43,
    y2: 180.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_161_21105",
    x1: 125.578,
    y1: 121.406,
    x2: 108.489,
    y2: 180.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_161_21105",
    x1: 128.641,
    y1: 154.523,
    x2: 128.641,
    y2: 84.4865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3144,
    stopColor: "#1493B7",
    stopOpacity: 0.6856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#285A72",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8795,
    stopColor: "#343647",
    stopOpacity: 0.1205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_161_21105",
    x1: 104.088,
    y1: 161.779,
    x2: 104.088,
    y2: 84.3615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#02C9F8",
    stopOpacity: 0.8957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#07BAE5",
    stopOpacity: 0.7465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4297,
    stopColor: "#10A0C6",
    stopOpacity: 0.5703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6265,
    stopColor: "#1C7C9B",
    stopOpacity: 0.3735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    stopColor: "#2C4F65",
    stopOpacity: 0.1623
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_161_21105",
    x1: 181.448,
    y1: 209.845,
    x2: 181.448,
    y2: 166.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_161_21105",
    x1: 130.25,
    y1: 180.177,
    x2: 183.353,
    y2: 207.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_161_21105",
    x1: 174.5,
    y1: 147.93,
    x2: 157.41,
    y2: 207.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_161_21105",
    x1: 177.562,
    y1: 181.048,
    x2: 177.562,
    y2: 111.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3144,
    stopColor: "#1493B7",
    stopOpacity: 0.6856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#285A72",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8795,
    stopColor: "#343647",
    stopOpacity: 0.1205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_161_21105",
    x1: 153.01,
    y1: 188.303,
    x2: 153.01,
    y2: 110.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#02C9F8",
    stopOpacity: 0.8957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#07BAE5",
    stopOpacity: 0.7465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4297,
    stopColor: "#10A0C6",
    stopOpacity: 0.5703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6265,
    stopColor: "#1C7C9B",
    stopOpacity: 0.3735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    stopColor: "#2C4F65",
    stopOpacity: 0.1623
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_161_21105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9802 125.264) scale(1.8109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF13BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_161_21105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.792 97.3756) scale(1.8109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF13BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_161_21105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.6326 148.662) scale(1.811 1.81099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF13BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_161_21105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.885 143.275) scale(2.77491 2.7749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF13BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_161_21105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.276 155.097) scale(0.7409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF13BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_161_21105",
    x1: 22.5509,
    y1: 251.019,
    x2: 56.1032,
    y2: 214.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282A57",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4537,
    stopColor: "#8788A1",
    stopOpacity: 0.6722
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_161_21105",
    x1: 31.0611,
    y1: 241.342,
    x2: 51.3746,
    y2: 219.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282A57",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4537,
    stopColor: "#8788A1",
    stopOpacity: 0.6722
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_161_21105",
    x1: 35.9077,
    y1: 190.599,
    x2: 43.6618,
    y2: 190.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A43F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642F41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_161_21105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(238.645 191.579) rotate(-3.83008) scale(3.89183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1436,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2573,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3723,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4891,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6083,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8584,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_161_21105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.575 180.149) rotate(-3.83008) scale(2.16947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1436,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2573,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3723,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4891,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6083,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8584,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_161_21105",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.178 170.274) rotate(-3.83009) scale(2.16947 2.16947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1436,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2573,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3723,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4891,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6083,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8584,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_161_21105",
    x1: 43.7339,
    y1: 106.965,
    x2: 42.4004,
    y2: -47.0357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3144,
    stopColor: "#1493B7",
    stopOpacity: 0.6856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#285A72",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8795,
    stopColor: "#343647",
    stopOpacity: 0.1205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_161_21105",
    x1: 56.881,
    y1: 15.1529,
    x2: 56.881,
    y2: 76.7826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#FF4174"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_161_21105",
    x1: 91.0466,
    y1: 141.387,
    x2: 91.0466,
    y2: 105.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_161_21105",
    x1: 48.4436,
    y1: 116.699,
    x2: 92.6325,
    y2: 139.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_161_21105",
    x1: 85.2663,
    y1: 89.8658,
    x2: 71.0454,
    y2: 139.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_161_21105",
    x1: 91.0466,
    y1: 131.789,
    x2: 91.0466,
    y2: 96.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_161_21105",
    x1: 48.4436,
    y1: 107.101,
    x2: 92.6324,
    y2: 129.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_161_21105",
    x1: 85.2663,
    y1: 80.2675,
    x2: 71.0454,
    y2: 129.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#FF4174"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_161_21105",
    x1: 27.2199,
    y1: 55.7589,
    x2: 27.2199,
    y2: 104.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#FF4174"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_161_21105",
    x1: 79.1906,
    y1: 77.8306,
    x2: 87.7822,
    y2: 70.3421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_161_21105",
    x1: 80.2143,
    y1: 97.5457,
    x2: 78.2792,
    y2: 57.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_161_21105",
    x1: 74.1213,
    y1: 96.819,
    x2: 72.1862,
    y2: 56.4165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_161_21105",
    x1: 69.662,
    y1: 82.2337,
    x2: 68.6558,
    y2: 74.5711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_161_21105",
    x1: 143.068,
    y1: 283.879,
    x2: 143.068,
    y2: 265.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_161_21105",
    x1: 120.871,
    y1: 271.016,
    x2: 143.894,
    y2: 282.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_161_21105",
    x1: 140.057,
    y1: 257.036,
    x2: 132.647,
    y2: 282.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_161_21105",
    x1: 163.068,
    y1: 296.545,
    x2: 163.068,
    y2: 277.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_161_21105",
    x1: 140.871,
    y1: 283.683,
    x2: 163.894,
    y2: 295.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2589,
    stopColor: "#64E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#EAEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_161_21105",
    x1: 160.057,
    y1: 269.702,
    x2: 152.647,
    y2: 295.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5155D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_161_21105",
    x1: 287.404,
    y1: 311.57,
    x2: 287.404,
    y2: 366.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_161_21105",
    x1: 267.105,
    y1: 320.025,
    x2: 307.734,
    y2: 320.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#FF4174"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_161_21105",
    x1: 287.442,
    y1: 250.376,
    x2: 287.442,
    y2: 296.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282A57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729,
    stopColor: "#484A70",
    stopOpacity: 0.0729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1952,
    stopColor: "#787A96",
    stopOpacity: 0.1952
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3211,
    stopColor: "#A2A3B6",
    stopOpacity: 0.3211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4487,
    stopColor: "#C4C4D1",
    stopOpacity: 0.4487
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5786,
    stopColor: "#DEDEE5",
    stopOpacity: 0.5786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    stopColor: "#F0F0F3",
    stopOpacity: 0.7114
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#FBFBFC",
    stopOpacity: 0.8493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_161_21105",
    x1: 327.071,
    y1: 290.903,
    x2: 327.071,
    y2: 345.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#05C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    stopColor: "#05B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    stopColor: "#04A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    stopColor: "#047EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_161_21105",
    x1: 327.442,
    y1: 229.876,
    x2: 327.442,
    y2: 276.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282A57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729,
    stopColor: "#484A70",
    stopOpacity: 0.0729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1952,
    stopColor: "#787A96",
    stopOpacity: 0.1952
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3211,
    stopColor: "#A2A3B6",
    stopOpacity: 0.3211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4487,
    stopColor: "#C4C4D1",
    stopOpacity: 0.4487
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5786,
    stopColor: "#DEDEE5",
    stopOpacity: 0.5786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    stopColor: "#F0F0F3",
    stopOpacity: 0.7114
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#FBFBFC",
    stopOpacity: 0.8493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_161_21105",
    x1: 238.062,
    y1: 156.319,
    x2: 238.062,
    y2: 209.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#FF4174"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_161_21105",
    x1: 266.018,
    y1: 206.819,
    x2: 266.018,
    y2: 237.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#05C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    stopColor: "#05B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    stopColor: "#04A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    stopColor: "#047EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_161_21105",
    x1: 287.496,
    y1: 202.819,
    x2: 287.496,
    y2: 254.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#05C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    stopColor: "#05B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    stopColor: "#04A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    stopColor: "#047EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_161_21105",
    x1: 261.923,
    y1: 243.009,
    x2: 295.233,
    y2: 243.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#05C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4439,
    stopColor: "#05B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7087,
    stopColor: "#04A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    stopColor: "#047EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_161_21105",
    x1: 261.048,
    y1: 243.653,
    x2: 261.048,
    y2: 297.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDF7A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_161_21105",
    x1: 261.048,
    y1: 216.986,
    x2: 261.048,
    y2: 268.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDF7A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_161_21105",
    x1: 215.692,
    y1: 226.986,
    x2: 215.692,
    y2: 269.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#E02D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_161_21105",
    x1: 234.403,
    y1: 178.319,
    x2: 234.403,
    y2: 261.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#FF4174"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_161_21105",
    x1: 244.442,
    y1: 117.326,
    x2: 244.442,
    y2: 202.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282A57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729,
    stopColor: "#484A70",
    stopOpacity: 0.0729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1952,
    stopColor: "#787A96",
    stopOpacity: 0.1952
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3211,
    stopColor: "#A2A3B6",
    stopOpacity: 0.3211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4487,
    stopColor: "#C4C4D1",
    stopOpacity: 0.4487
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5786,
    stopColor: "#DEDEE5",
    stopOpacity: 0.5786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    stopColor: "#F0F0F3",
    stopOpacity: 0.7114
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#FBFBFC",
    stopOpacity: 0.8493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBanner);
export default __webpack_public_path__ + "static/media/login-banner.39640e3ea30e98c14ae98cb8c69311f3.svg";
export { ForwardRef as ReactComponent };